import { usePortalAuthStore } from '@/stores/portal-auth';

export function usePortalAuth() {
  const {
    user,
    empresa,
    accessToken,
    isAuthenticated,
    isInitialized,
    isLoading,
    error,
    login,
    logout,
    initializeAuth,
    clearError,
  } = usePortalAuthStore();

  return {
    user,
    empresa,
    accessToken,
    isAuthenticated,
    isInitialized,
    isLoading,
    error,
    login,
    logout,
    initializeAuth,
    clearError,
  };
}
